import keycloakAxios from '@/services/axios';

export const confirmEmployee = async (
  employeeId: string,
  companyId: string
) => {
  let endpoint = `company/employee/${employeeId}/confirm`;

  if (companyId) {
    endpoint = `company/${companyId}/employee/${employeeId}/confirm`;
  }

  const response = await keycloakAxios.get(endpoint);

  if (response.status >= 300) {
    throw new Error(
      `Error confirming employee: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};
